import { render, staticRenderFns } from "./costAnalysis.vue?vue&type=template&id=6967febe&scoped=true&"
import script from "./costAnalysis.vue?vue&type=script&lang=js&"
export * from "./costAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6967febe",
  null
  
)

export default component.exports